// Bosla's support contact as a link (UC-22): the owner's screens open a new
// mail and a WhatsApp chat. The till shows the same contact as plain text.

const LRI = String.fromCodePoint(0x2066);
const PDI = String.fromCodePoint(0x2069);

/** "WhatsApp +201001234567", the number kept left to right inside Arabic, as
 * the design's <bdi dir="ltr"> does. Built from code points, because the
 * isolate characters themselves are invisible in the source. */
export function whatsappLabel(word: string, number: string): string {
	return `${word} ${LRI}${number}${PDI}`;
}

/** The chat link for an E.164 number: wa.me takes the digits alone. */
export function whatsappHref(number: string): string {
	return `https://wa.me/${number.replace(/^\+/, '')}`;
}
